module.exports = __webpack_public_path__ + "img/55.ea16a700.jpg";